import { useConfigContext } from '../../../../../contexts/ConfigContext/ConfigContext';
import { NotificationSnackbar } from '../../NotificationSnackbar/NotificationSnackbar';

export function Logo() {
  const {
    state: { appTheme },
  } = useConfigContext();

  if (!appTheme) return null;

  return (
    <>
      <div>
        <NotificationSnackbar />
        <div style={{ width: 100 }}>
          <img
            src={appTheme?.logoUrl}
            alt="Logo"
            style={{
              maxWidth: '120px',
              maxHeight: '90px',
              borderRadius: '0px',
              width: '100%',
            }}
          />
        </div>
      </div>
    </>
  );
}
